module.exports = __webpack_public_path__ + "img/seaward_alaska.e39b4245.jpg";